module.exports = __webpack_public_path__ + "img/empty.370c8030.png";